import axios from "axios";
import { Response } from "../../../shared/models/Response";
import { GeneralRule } from "../models/GeneralRule";
import { RulesQuery } from "../models/RulesQuery.model";
import { RulesResponse } from "../models/RulesResponse.model";

export class GeneralRulesService {
  private baseUrl: string;

  constructor() {
    this.baseUrl = `${process.env.VUE_APP_RULES_API}/general-rule`;
  }

  async saveRule(generalRule: GeneralRule): Promise<Response<RulesResponse>> {
    const serviceURL = `${this.baseUrl}/save-rule`;
    const response = await axios.post(serviceURL, generalRule);
    return response.data;
  }

  async updateRule(
    generalRule: GeneralRule,
    id: string
  ): Promise<Response<RulesResponse>> {
    const serviceURL = `${this.baseUrl}/${id}`;
    const response = await axios.put(serviceURL, generalRule);
    return response.data;
  }

  async getGeneralRulesByFilters(
    query: RulesQuery
  ): Promise<Response<RulesResponse>> {
    const serviceURL = `${this.baseUrl}/get-charts`;
    const response = await axios.get(serviceURL, { params: query });
    return response.data;
  }

  async getGeneralRuleById(id: string): Promise<Response<GeneralRule>> {
    const serviceURL = `${this.baseUrl}/get-rule/${id}`;
    const response = await axios.get(serviceURL);
    return response.data;
  }

  async deleteRule(id: string): Promise<Response<RulesResponse>> {
    const serviceURL = `${this.baseUrl}/delete-rule/${id}`;
    const response = await axios.delete(serviceURL);
    return response.data;
  }

  async updateStateRuleById(
    id: string,
    state: string
  ): Promise<Response<string | void>> {
    const serviceUrl = `${this.baseUrl}/state/${id}/${state}`;
    const response = await axios.put(serviceUrl);
    return response.data;
  }

  async checkIfExistByName(name: string): Promise<Response<void>> {
    const serviceURL = `${this.baseUrl}/exist-by-name`;

    const params = {
      params: {
        nameRule: name
      }
    };

    const response = await axios.get(serviceURL, params);
    return response.data;
  }

  async duplicateRuleById(id: string): Promise<Response<string | void>> {
    const serviceUrl = `${this.baseUrl}/duplicate-rule/${id}`;
    const response = await axios.post(serviceUrl);
    return response.data;
  }
}
